"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAtlasEnv = getAtlasEnv;
exports.isBrand = isBrand;
exports.lockUtils = void 0;
exports.sortMarkets = sortMarkets;
var _atlas = require("@godaddy/atlas");
/**
 * @typedef {import('@godaddy/atlas').Market} Market
 * @typedef {import('@godaddy/atlas').Brand} Brand
 */

/**
 * Determine the Atlas environment to use.
 * @param {string} env - Atlas environment passed via props
 * @returns {string} The Atlas environment to use (i.e. dev, test, prod)
 */
function getAtlasEnv(env) {
  if (env) {
    return env;
  }
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname) {
      return (0, _atlas.envFromHostname)(hostname);
    }
  }
  return 'prod';
}

/**
 * Sort markets alphabetically by description.
 * @param {Market[]} markets
 * @returns {Market[]} sorted markets
 * @private
 */
function sortMarkets(markets) {
  return markets.slice().sort((aMarket, bMarket) => {
    return aMarket.description.localeCompare(bMarket.description);
  });
}

/**
 * Type guard to check if the provided object is valid Brand.
 * @param {*} maybeBrand - The brand object to validate
 * @returns {maybeBrand is Brand} True if valid brand object, false otherwise
 * @private
 * */
function isBrand(maybeBrand) {
  return maybeBrand && maybeBrand instanceof _atlas.Brand;
}

/**
 * Utilities to lock and unlock scrolling on the `document.body`.
 * Exported object allows for easier testing/mocking.
 * @type {object} lockUtils
 */
const lockUtils = exports.lockUtils = {
  /**
   * Add a class to set `overflow: hidden;`  on `document.body`.
   * This prevents scrolling of background content.
   *
   * TODO: Apply the Mobile Safari fix for GX-4564 when complete.
   */
  lockScroll(props) {
    //
    // Add className to the target to indicate that the TrayMenu is open.
    // This className ensures that the correct scroll bars are added when we
    // have content that is overflowing.
    //
    if (props.lockScrollOnOpen) {
      const target = document.body;
      target.classList.add('market-selector-open');
    }
  },
  /**
   * Add a class to set `overflow: hidden;`  on `document.body`.
   * This prevents scrolling of background content.
   *
   * TODO: Apply the Mobile Safari fix for GX-4564 when complete.
   */
  unlockScroll() {
    //
    // Remove className to the target to indicate that the TrayMenu is closed.
    //
    const target = document.body;
    target.classList.remove('market-selector-open');
  }
};